import { useWatch } from '@slal/ui/react-hook-form/core';
import { P } from '@slal/ui/typography';
import { ComponentPropsWithoutRef } from 'react';
import { FundAllocation } from '~/types';
import { StyledTargetFundAllocation } from './styles';

export const TargetFundAllocation = (props: ComponentPropsWithoutRef<'div'>) => {
    const fundAllocations = useWatch<{ fundAllocations: FundAllocation[] }>({
        name: 'fundAllocations',
    }) as FundAllocation[];
    if (!fundAllocations?.length) return;

    let total = 0;

    for (const { allocation } of fundAllocations) {
        const value = parseFloat(allocation);
        if (isNaN(value)) continue;
        total = total + value;
    }

    const remainder = parseFloat((100 - total).toFixed(2));
    const isOver100 = remainder < 0;

    return (
        <StyledTargetFundAllocation
            aria-label="Target fund allocation"
            {...props}
            level={isOver100 ? 'danger' : 'info'}
        >
            <P>{isOver100 ? 'Your current allocation is over 100%' : `Percentage left to allocate: ${remainder}%`}</P>
        </StyledTargetFundAllocation>
    );
};
